import { useRecordContext, Button, useNotify } from "react-admin";
import { candidateRequests } from "api/candidateApi";
import { useState, useCallback } from "react";
import { getFileFromUrl } from "server/components/DownloadFile";
import DownloadIcon from "@mui/icons-material/Download";
import { settings } from "app";
import { CircularProgress } from "@mui/material";

const ExportRankingButton = () => {
  const record = useRecordContext();
  const notify = useNotify();

  const [loading, setLoading] = useState(false);

  const exportResults = useCallback(async () => {
    setLoading(true);

    const fileName = `класиране_${record?.id}_${record?.rankingNumber}.xlsx`;
    const exportUrl = `${settings.gatewayApi}/${candidateRequests.exportCampaignRanking(record?.id)}`;

    await getFileFromUrl(exportUrl, fileName, notify);

    setLoading(false);
  }, [notify, record?.id, record?.rankingNumber]);

  return (
    <Button
      label="Изтегляне"
      onClick={exportResults}
      variant="contained"
      size="medium"
      disabled={loading}
    >
      {loading ? <CircularProgress size={20} /> : <DownloadIcon />}
    </Button>
  );
};

export default ExportRankingButton;
